<core-ui-error-page
  title="{{ 'GENERAL.ERROR_PAGE.TITLE' | translate }}"
  description="{{ 'GENERAL.ERROR_PAGE.DESCRIPTION' | translate }}"
  buttonText="{{ 'GENERAL.ERROR_PAGE.BUTTON' | translate }}"
  [darkMode]="colorScheme === ColorScheme.DARK"
>
  <core-ui-navbar>
    @let loading = loading$ | async;
    @if (loading) {
      <mat-spinner class="loading-indicator" color="primary"></mat-spinner>
    }
    <div class="company-header">
      @if (companyName) {
        <h2 class="company-header">
          <span class="company-text">{{ 'GENERAL.SELECTED_COMPANY' | translate }}</span>
          {{ companyName }}
        </h2>
      }
    </div>
    <router-outlet></router-outlet>
  </core-ui-navbar>
</core-ui-error-page>
